const OurMissionPage = () => {
    return (
        <>
            <h1>OurMission Page</h1>
        </>
    )
}


export default OurMissionPage;